import cx from 'clsx';

import BreakdownDonutChart from 'features/dashboard/components/BreakdownDonutChart';
import styles from 'theme/features/dashboard/dashboard-site-wide.module.scss';

const SiteChart = ({ overview, isCompact }) => (
  <section className={cx(styles.chart, isCompact && styles['chart--compact'])}>
    <div className={styles['chart__donuts']}>
      <BreakdownDonutChart
        compact={isCompact}
        title="Total Usable/Plannable Area Breakdown"
        colors={{
          Collaborative: styles.collaborative,
          Individual: styles.individual,
          Community: styles.community,
          Support: styles.support,
          'Specialty Spaces': styles.specialty,
          'Site Specific': styles['site-specific']
        }}
        data={
          overview
            ? [
                {
                  group: 'Collaborative',
                  value: overview.areaBreakdown.collaborative
                },
                {
                  group: 'Individual',
                  value: overview.areaBreakdown.individual
                },
                {
                  group: 'Community',
                  value: overview.areaBreakdown.community
                },
                {
                  group: 'Support',
                  value: overview.areaBreakdown.support
                },
                {
                  group: 'Specialty Spaces',
                  value: overview.areaBreakdown.specialtySpaces
                },
                {
                  group: 'Site Specific',
                  value: overview.areaBreakdown.siteSpecificSpaces
                }
              ]
            : null
        }
      />
      <br />
      <BreakdownDonutChart
        compact={isCompact}
        title="Capacity Breakdown"
        colors={{
          'Enclosed Collaborative': '#b4c7e7',
          'Open Collaborative': '#dae3f3',
          'Enclosed Individual': '#01f9e7',
          'Open Individual': '#c0feff',
          Workstations: '#f4b183',
          'Site Requirements': '#a9d18e'
        }}
        data={
          overview
            ? [
                {
                  group: 'Enclosed Collaborative',
                  value: overview.capacityBreakdown.enclosedCollab
                },
                {
                  group: 'Open Collaborative',
                  value: overview.capacityBreakdown.openCollab
                },
                {
                  group: 'Enclosed Individual',
                  value: overview.capacityBreakdown.enclosedIndiv
                },
                {
                  group: 'Open Individual',
                  value: overview.capacityBreakdown.openIndiv
                },
                {
                  group: 'Workstations',
                  value: overview.capacityBreakdown.workstations
                },
                {
                  group: 'Site Requirements',
                  value: overview.capacityBreakdown.siteRequirements
                }
              ]
            : null
        }
      />
    </div>
  </section>
);

export default SiteChart;
